import { ChangeDetectionStrategy, Component, EventEmitter, input, Output } from '@angular/core';
import { PortalWidgetDetailsComponent } from '../../portal-widget-details/portal-widget-details.component';
import { CtrlIconComponent } from '@co-3/ctrl-ui/icons';
import { Customer } from '@models/customer';

@Component({
    selector: 'app-login-credentials-display',
    templateUrl: './login-credentials-display.component.html',
    styleUrls: ['./login-credentials-display.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [PortalWidgetDetailsComponent, CtrlIconComponent],
})
export class LoginCredentialsDisplayComponent {
    @Output()
    public edit = new EventEmitter<void>();

    public customer = input.required<Customer>();
}
